import { useNavigate } from 'react-router-dom'
import RuleForm from '../components/RuleForm'

import { useRule } from '@/features/rules/useRule'

const AddRule = () => {
  const { useCreateRule } = useRule()
  const newRule = {
    name: '',
    type: '',
    offerType: 'all',
    hasUpperLimit: false,
    hasLowerLimit: false,
    currency: 'HKD',
  }

  const createRule = useCreateRule()
  const navigate = useNavigate()

  const onSubmit = async (data) => {
    console.log('In Add rule Page: ', data)
    createRule.mutate(
      { data },
      {
        onSuccess: () => {
          navigate('/admin/rules/')
        },
      }
    )
  }

  return <RuleForm onSubmitAction={onSubmit} rule={newRule} />
}

export default AddRule
